export const GET_COHORT = 'GET_COHORT'
export const GET_COHORT_ORGANIZATIONS = 'GET_COHORT_ORGANIZATIONS'
export const GET_COHORT_ORGANIZATIONS_LOADING = 'GET_COHORT_ORGANIZATIONS_LOADING'
export const GET_COHORT_SELECTION_LIMIT = 'GET_COHORT_SELECTION_LIMIT'
